<div class="page">
  <header class="brijjsports-page-head">
    <p class="brijjsports-page-kicker">Coach · Archery</p>
    <h1 class="brijjsports-page-title">New scoring session</h1>
    <p class="brijjsports-page-sub">
      Configure rounds and assign archers — preview shows {{ previewArrows() }} arrows / max {{ previewMax() }} points.
    </p>
  </header>

  <mat-stepper linear orientation="vertical" class="setup-stepper">
    <!-- Step 1 — Basics -->
    <mat-step [stepControl]="basicsForm" label="Session basics">
      <form [formGroup]="basicsForm" class="setup-form">
        <mat-form-field appearance="outline">
          <mat-label>Session name</mat-label>
          <input matInput formControlName="name" maxlength="80" />
          <mat-hint align="end">{{ basicsForm.controls.name.value.length }}/80</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Mode</mat-label>
          <mat-select formControlName="mode">
            @for (m of modeOptions; track m.value) {
              <mat-option [value]="m.value">{{ m.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="setup-toggles">
          <mat-button-toggle-group formControlName="indoor" aria-label="Indoor or outdoor">
            <mat-button-toggle [value]="true">Indoor</mat-button-toggle>
            <mat-button-toggle [value]="false">Outdoor</mat-button-toggle>
          </mat-button-toggle-group>

          <mat-slide-toggle formControlName="compoundInner10">Compound inner-10 (X = 11)</mat-slide-toggle>
        </div>

        <div class="setup-actions">
          <button mat-button type="button" (click)="cancel()">Cancel</button>
          <button mat-flat-button color="primary" type="button" matStepperNext [disabled]="basicsForm.invalid">
            Next: Rounds
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 2 — Rounds -->
    <mat-step [stepControl]="roundsForm" label="Rounds">
      <form [formGroup]="roundsForm" class="setup-form">
        <div class="round-list">
          @for (group of rounds.controls; track $index; let i = $index) {
            <div class="round-row" [formGroup]="group">
              <span class="round-row__index">Round {{ i + 1 }}</span>

              <mat-form-field appearance="outline">
                <mat-label>Format</mat-label>
                <mat-select formControlName="format">
                  @for (f of roundFormatOptions; track f.value) {
                    <mat-option [value]="f.value">{{ f.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Ends</mat-label>
                <input matInput type="number" formControlName="endsCount" min="4" max="30" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Arrows / end</mat-label>
                <input matInput type="number" formControlName="arrowsPerEnd" min="1" max="6" />
              </mat-form-field>

              <button
                mat-icon-button
                type="button"
                aria-label="Remove round"
                [disabled]="rounds.length <= 1"
                (click)="removeRound(i)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          }
        </div>

        <button mat-stroked-button type="button" (click)="addRound()" [disabled]="rounds.length >= 6">
          <mat-icon>add</mat-icon>
          Add round
        </button>

        <div class="setup-actions">
          <button mat-button type="button" matStepperPrevious>Back</button>
          <button mat-flat-button color="primary" type="button" matStepperNext [disabled]="roundsForm.invalid">
            Next: Archers
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 3 — Archers -->
    <mat-step label="Archers">
      <p class="setup-hint">Select participating archers. Lane mode also assigns lanes and positions.</p>

      @if (availableArchers().length) {
        <div class="archer-grid">
          @for (a of availableArchers(); track a.id) {
            <app-coach-scoring-setup-archer-pick-row
              [athlete]="a"
              [picked]="isPicked(a.id)"
              [showLane]="basicsForm.controls.mode.value === byLaneMode"
              [laneNumber]="laneFor(a.id)"
              [position]="positionFor(a.id)"
              (selectionToggle)="toggleArcher(a.id)"
              (laneChange)="updateLane(a.id, $event)"
              (positionChange)="updatePosition(a.id, $event)"
            />
          }
        </div>
      } @else {
        <p class="brijjsports-empty">No archery athletes available on your roster.</p>
      }

      <div class="setup-actions">
        <button mat-button type="button" matStepperPrevious>Back</button>
        <button mat-flat-button color="primary" type="button" (click)="start()" [disabled]="!canStart()">
          Start session
        </button>
      </div>
    </mat-step>
  </mat-stepper>
</div>
